import { graphql } from "relay-runtime"
import { useMutationWithErrorDialog } from "@/hooks/useMutationWithErrorDialog"
import { useChUpdateProgressNoteCareProviderMutation as useChUpdateProgressNoteCareProviderMutationType } from "@/modules/patients/services/ch/__generated__/useChUpdateProgressNoteCareProviderMutation.graphql"

export const Ch_updateProgressNoteCareProviderMutation = graphql`
  mutation useChUpdateProgressNoteCareProviderMutation($input: Ch_updateProgressNoteCareProviderInput!) {
    ch_updateProgressNoteCareProvider(input: $input) {
      ch_ProgressNoteMutationOutput {
        progressNote {
          id
          updatedAt
          pointOfCare {
            careProviderId
            careProvider {
              id
              firstName
              lastName
              businessName
            }
          }
        }
      }
      errors {
        ... on Error {
          message
        }
      }
    }
  }
`

export const useChUpdateProgressNoteCareProviderMutation = () => {
  return useMutationWithErrorDialog<useChUpdateProgressNoteCareProviderMutationType>(
    Ch_updateProgressNoteCareProviderMutation,
  )
}
